/**
 * @readonly
 * @enum {strring}
 * 购物车加购步进器类型
 */

export const NEW_ADD_CART_STEP = {
  normal: {
    noticeInputBtnWidth: 1.6, // 80px => 1.6rem
    plusMinusBtnWidth: 0.48 // 24px=> 0.48rem
  },
  large: {
    noticeInputBtnWidth: 1.92, // 96px => 1.92rem
    plusMinusBtnWidth: 0.64 // 32px=>0.64rem
  }
}
